import { defineStore } from "pinia";
import { productService } from "~/services/product.service";
import { handleCommonActions } from "~/utils/store.util";
import { usePaginationStore } from "@/stores/common/pagination.store";

export const useProductStore = defineStore("product", {
    state: () => ({
        
        products: [],
        variations: [],
        product: null,
    }),
    actions: {
        setSearch(payload = {}) {
            this.search = {
                ...this.search,
                ...payload,
            };
        },
        setAvailableFilters(filters = []) {
            this.availableFilters.variants = {};

            filters.map((filter) => {
                if (filter?.type === "category") {
                    this.availableFilters.categories = filter?.items ?? [];
                } else if (filter?.type === "brand") {
                    this.availableFilters.brands = filter?.items ?? [];
                } else if (filter?.type === "unit") {
                    this.availableFilters.units = filter?.items ?? [];
                } else if (filter?.type === "variant") {
                    this.availableFilters.variants[`variant-${filter.name}`] = {
                        title: filter?.name ?? null,
                        items: filter?.items ?? [],
                    };
                }
            });
        },
        async fetchProducts(payload = {}) {
            const paginationStore = usePaginationStore();
            
            return await handleCommonActions(async () => {
                const response = await productService.index({
                    ...paginationStore.paginationDataForRequest,
                    ...this.search,
                    ...payload,
                });

                const products = response?.data ?? [];
                
                this.products = [...products];
                // console.log("response fetchProducts", response);
                
                paginationStore.setPaginationData(response?.headers ?? {});
                this.setAvailableFilters(response.data?.filters ?? []);
            });
        },
        async fetchProduct(id) {
            return await handleCommonActions(async () => {
                const response = await productService.getProduct(id);
                
                this.product = response?.data ?? null;
            });
        },
        async fetchVariations(id) {
            return await handleCommonActions(async () => {
                const response = await productService.getVariations(id);
                
                this.variations = response?.data ?? null;
            });
        },
    },
});
